import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ContactAvatarCell } from '@/components/table/ContactAvatarCell';
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/macro';
import type { Contact } from '@/types/contact';

interface ContactListItemProps {
  contact: Contact;
  selected: boolean;
}

export function ContactListItem({ contact, selected }: ContactListItemProps) {
  const { i18n } = useLingui();

  return (
    <>
      <Check
        className={cn(
          "mr-2 h-4 w-4",
          selected ? "opacity-100" : "opacity-0"
        )}
        aria-hidden="true"
        focusable="false"
      />
      <div className="flex-1">
        <ContactAvatarCell
          contact={contact}
          nonClickable
          showEmail
          hideDetailsLabel={false}
        />
      </div>
      {/* Screen reader only text to communicate selection state */}
      {selected && (
        <span className="sr-only">{i18n._(msg`Selected`)}</span>
      )}
    </>
  );
}